module.exports = __webpack_public_path__ + "img/objetivo_16.e4541817.webp";